import { Injectable } from '@angular/core';
import { Observable, Subscriber, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentProvider } from '../models/payment-provider';
import { Order } from '../../order/models/order';
import { OrderStateService } from '../../order/services/order-state.service';
import { PaymentService } from './payment.service';
import { GiftCard } from '../../giftcard/models/giftcard';
import { JSONUtilites } from '../.../../../../helpers/JSONUtilites';
import { environment } from '../../../../environments/environment';
import { GlobalSettings } from '../../../../environments/global-settings';
import { DiscountCoupon } from '../models/discount-coupon';
import { InMemoryDiscountCoupons } from '../models/in-memory-discount-coupons';
import { GiftCardService } from '../../giftcard/services/giftcard.service';
import { GiftCardInMemoryService } from '../../giftcard/services/giftcard-in-memory.service';
import { PrepaidPaymentInfo } from '../models/prepaid-payment-info';
import { Location } from '@angular/common';

@Injectable()
export class PaymentInMemoryService implements PaymentService {

  constructor(
    private giftCardService: GiftCardService,
    private location: Location,
  ) {

  }

  private _paymentProviders: PaymentProvider[] = [
    new PaymentProvider(1, 'Visa'),
    new PaymentProvider(2, 'Paypal'),
    new PaymentProvider(3, 'Sofort'),
  ];

  paymentTransaction(orderId: number, paymentProviderId: number): Observable<string> {
    return of(`
    <form action="simulator/acquirer" method="get" target="_self">
      <input type="hidden" name="return_url" value="${this.location.prepareExternalUrl('/payment/return/')}${orderId}" />
      <input type="hidden" name="cancel_url" value="${this.location.prepareExternalUrl('/payment/return/')}${orderId}" />
    </form>
    `);
  }

  paymentGuestTransaction(orderId: number,  guestOrderKey: string, paymentProviderId: number): Observable<string> {
    return this.paymentTransaction(orderId, paymentProviderId);
  }

  payOrderByGiftCard(orderId: number): Observable<boolean> {
    // TODO simulation
    return of();
  }

  guestPayOrderByGiftCard(orderId: number): Observable<string> {
    // TODO simulation
    return of();
  }

  payOrderByCash(orderId: number): Observable<boolean> {
    // TODO simulation
    return of();
  }

  getPaymentProviders(): Observable<PaymentProvider[]> {
    return of(this._paymentProviders);
  }

  prepaidOrder(orderNumber: number, giftCardRedeems: GiftCard[], discountCoupon: DiscountCoupon[]): Observable<PrepaidPaymentInfo> {
    const giftCardInMemoryService = this.giftCardService as GiftCardInMemoryService;
    if (giftCardInMemoryService) {
      return giftCardInMemoryService.applyOrderGiftCardPayments(orderNumber, giftCardRedeems).pipe(map(
        result => {
          return new PrepaidPaymentInfo(null, result, 0);
        }
      ));

    }
    return of();
  }

  prepaidGuestOrder(orderNumber: number, giftCardRedeems: GiftCard[], discountCoupon: DiscountCoupon[]): Observable<PrepaidPaymentInfo> {
    return this.prepaidOrder(orderNumber, giftCardRedeems, discountCoupon);
  }
}
